import { z } from 'zod';
/** Media type every error response must use. */
export const PROBLEM_CONTENT_TYPE = 'application/problem+json';
/** One field-level validation failure. Paths only — never echo the offending value (§4: no PII in logs or responses). */
export const ProblemErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
});
/**
 * RFC 9457 problem details. Not strict: the server may add extension members,
 * and a client parsing an unknown extension must not fail.
 */
export const ProblemSchema = z.object({
    /** URI reference identifying the problem type, e.g. `about:blank#validation-error`. */
    type: z.string().min(1),
    /** Short, human-readable summary. Safe to display; never contains internals. */
    title: z.string().min(1),
    status: z.number().int().min(100).max(599),
    /** Explanation specific to this occurrence. */
    detail: z.string().optional(),
    /** URI reference identifying the specific occurrence. */
    instance: z.string().optional(),
    /** Extension member: field-level detail for validation failures. */
    errors: z.array(ProblemErrorSchema).optional(),
});
/**
 * Flattens Zod issues into `Problem.errors`. Keeps the shape identical across the
 * backend handlers and the agent's tool-input validation.
 */
export function toProblemErrors(issues) {
    return issues.map((issue) => ({
        path: issue.path.length > 0 ? issue.path.join('.') : '(root)',
        message: issue.message,
    }));
}
//# sourceMappingURL=problem.js.map